import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Input,
    InputGroup,
    InputGroupText,
    Modal,
    Row, Spinner
} from 'reactstrap';
import {
    CURRENCY_MXN_HEADER,
    CURRENCY_USD_HEADER,
    error,

    infoMsg,
 PRICE_BOTTLE_HEADER, PRICE_CUP_HEADER,

    saveMsg,
    success
} from "../../../../components/i18n/i18n";
import {useForm} from "react-hook-form";
import {GenericButton} from "../../../../components/buttons/customButtons";
import {TT_CLOSE, TT_DELETE, TT_SAVE} from "../../../../components/i18n/toolTips";
import Separator from "../../../../components/Separator";
import {dishDrinkPriceService} from "../../../../jwt/_services/ayb/dishDrinkPriceService";
import {showToastCustom} from "../../../../components/toast/customToast";


export const SauserSectionPrices = forwardRef((props, ref) => {
    const [parent] = useState(props.parent || null);

    const [app] = useState(props.app || null);

    const [modal, setModal] = useState(false);

    const [item, setItem] = useState(null);

    const [saving, setSaving] = useState(false)

    const [priceUSD, setPriceUSD] = useState('0.00')
    const [priceMXN, setPriceMXN] = useState('0.00')
    const [priceCupMXN, setPriceCupMXN] = useState('0.00')
    const [priceCupUSD, setPriceCupUSD] = useState('0.00')
    const [priceIdUSD, setPriceIdUSD] = useState(null)
    const [priceIdMXN, setPriceIdMXN] = useState(null)
    const [priceCupIdUSD, setPriceCupIdUSD] = useState(null)
    const [priceCupIdMXN, setPriceCupIdMXN] = useState(null)

    const {register, handleSubmit, reset } = useForm({
        defaultValues: {
            priceUSD: '0.00',
            priceMXN: '0.00',
            priceCupMXN: '0.00',
            priceCupUSD: '0.00',
        }
    });

    const isMounted = useRef(true)

    //Actualizar la referencia
    useEffect(() => {
        return () => {
            isMounted.current = false
        }
    },[])

    const onSubmit = (data, _) => {
        const dataRequest = {
            fbDataBase :  { id : app?.fbDataBase?.id },
            item : {
                items : [ ]
            }
        }

        if (parseFloat(priceMXN) > 0) {
            dataRequest.item.items = [
                ...dataRequest.item.items,
                {
                    id : priceIdMXN,
                    currency : { currency : 'MXN' },
                    dishDrink : { id : item.id },
                    presentationType : 'BOTTLE',
                    price : priceMXN
                }
            ]
        }

        if (parseFloat(priceUSD) > 0) {
            dataRequest.item.items = [
                ...dataRequest.item.items,
                {
                    id: priceIdUSD,
                    currency : { currency : 'USD' },
                    dishDrink : { id : item.id },
                    presentationType : 'BOTTLE',
                    price : priceUSD
                }
            ]
        }

        if (parseFloat(priceCupMXN) > 0) {
            dataRequest.item.items = [
                ...dataRequest.item.items,
                {
                    id : priceCupIdMXN,
                    currency : { currency : 'MXN' },
                    dishDrink : { id : item.id },
                    presentationType : 'CUP',
                    price : priceCupMXN
                }
            ]
        }

        if (parseFloat(priceCupUSD) > 0) {
            dataRequest.item.items = [
                ...dataRequest.item.items,
                {
                    id : priceCupIdUSD,
                    currency : { currency : 'USD' },
                    dishDrink : { id : item.id },
                    presentationType : 'CUP',
                    price : priceCupUSD
                }
            ]
        }

        setSaving(true)
        dishDrinkPriceService.saveItem(dataRequest)
            .then(result => {
                if(!result?.status)
                    return

                showToastCustom(success, saveMsg);
            })
            .catch( e => {
                    console.log("Error en la asignacion", e);
                    showToastCustom(error, infoMsg, true);
                }
            )
            .finally(() => {
                if(isMounted.current) {
                    setSaving(false)
                }
                props.refreshList();
                setModal(!modal);
            });
    };

    const showModal = () => {
        setModal(!modal);
    }

    useImperativeHandle(ref, () => ({
        showModal(_item, _index) {
            console.log(_item, _index)
            let _priceMXN = '0.00'
            let _priceUSD = '0.00'
            let _priceCupMXN = '0.00'
            let _priceCupUSD = '0.00'

            _item.prices.map(price => {
                if (price.currencyCode === 'MXN' && (price.presentationType === null || price.presentationType === 'BOTTLE')) {
                    _priceMXN = price.price
                    setPriceMXN(price.price)
                    setPriceIdMXN(price.id || null)
                }

                if (price.currencyCode === 'USD' && (price.presentationType === null || price.presentationType === 'BOTTLE')) {
                    _priceUSD = price.price
                    setPriceUSD(price.price)
                    setPriceIdUSD(price.id || null)
                }

                if (price.currencyCode === 'MXN' && price.presentationType === 'CUP') {
                    _priceCupMXN = price.price
                    setPriceCupMXN(price.price)
                    setPriceCupIdMXN(price.id || null)
                }

                if (price.currencyCode === 'USD' && price.presentationType === 'CUP') {
                    _priceCupUSD = price.price
                    setPriceCupUSD(price.price)
                    setPriceCupIdUSD(price.id || null)
                }
            });

            setItem( _item );
            setModal(!modal);
            reset({
                priceUSD: _priceUSD,
                priceMXN: _priceMXN,
                priceCupMXN: _priceCupMXN,
                priceCupUSD: _priceCupUSD,
            });
        }
    }));

    const notImplemented = () => {
        console.log('Not implemented')
    }


    return <Modal isOpen={modal} toggle={showModal} modalClassName="menu-modal-form">
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <>
                    <h2 className={'card-modal-title'} > {  parent?.title + '  /  ' + (item?.title || ' / Precios') }</h2>
                    <br />
                    <h5 className={'card-modal-uid'} > { '     uid: ' + item?.uid }</h5>
                </>
                <div className="top-right">

                    {
                        saving ? <>
                            <Spinner animation="border" size='sm' type='grow'/>
                            <Spinner animation="border" size='sm' type='grow'/>
                            <Spinner animation="border" size='sm' type='grow'/>
                        </> :
                            <GenericButton
                                style={'table'}
                                icon={'fa-save'}
                                toolTip={TT_SAVE}
                                permission={'add'}
                                onClick={onSubmit}
                            />
                    }
                    {
                        item?.id &&
                        <>
                            <Separator/>
                            <GenericButton
                                style={'danger-secondary'}
                                toolTip={TT_DELETE}
                                icon={'fa-trash'}
                                permission={'delete'}
                                onClick={notImplemented}
                            />
                        </>
                    }
                    <Separator/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_CLOSE}
                        icon={'fa-times'}
                        permission={'search'}
                        onClick={showModal}
                    />
                </div>
            </CardTitle>
            <CardBody>
                <Row>
                    <Col md={"4"}/>
                    <Col md={"4"}><h4 style={ {textAlign:'center'} }>{CURRENCY_USD_HEADER}</h4></Col>
                    <Col md={"4"}><h4 style={ {textAlign:'center'} }>{CURRENCY_MXN_HEADER}</h4></Col>
                </Row>
                <Row>
                    <Col md={"4"}>{ PRICE_BOTTLE_HEADER }</Col>
                    <Col md={"4"} style={ { borderRight:'solid' } }>
                        <InputGroup>
                            <InputGroupText>$</InputGroupText>
                            <Input
                                type="number"
                                step=".01"
                                min="0.00"
                                name="priceUSD"
                                value={priceUSD}
                                onChange={e => setPriceUSD(e.target.value)}
                                placeholder={''}
                                innerRef={register}
                            />
                        </InputGroup>
                    </Col>
                    <Col md={"4"}>
                        <InputGroup>
                            <InputGroupText>$</InputGroupText>
                            <Input
                                type="number"
                                step=".01"
                                min="0.00"
                                name="priceMXN"
                                value={priceMXN}
                                onChange={e => setPriceMXN(e.target.value)}
                                placeholder={''}
                                innerRef={register}
                            />
                        </InputGroup>
                    </Col>
                </Row>
                <br/>
                <br/>
                <Row>
                    <Col md={"4"}>{ PRICE_CUP_HEADER }</Col>
                    <Col md={"4"} style={ { borderRight:'solid' } }>
                        <InputGroup>
                            <InputGroupText>$</InputGroupText>
                            <Input
                                type="number"
                                step=".01"
                                min="0.00"
                                name="priceCupUSD"
                                value={priceCupUSD}
                                onChange={e => setPriceCupUSD(e.target.value)}
                                placeholder={''}
                                innerRef={register}
                            />
                        </InputGroup>
                    </Col>
                    <Col md={"4"}>
                        <InputGroup>
                            <InputGroupText>$</InputGroupText>
                            <Input
                                type="number"
                                step=".01"
                                min="0.00"
                                name="priceCupMXN"
                                value={priceCupMXN}
                                onChange={e => setPriceCupMXN(e.target.value)}
                                placeholder={''}
                                innerRef={register}
                            />
                        </InputGroup>
                    </Col>
                </Row>
            </CardBody>


        </Card>
    </Modal>
})